/**
 *
 * @param ttl - time to live in minutes
 */
export default (ttl) => {
  let timer = ttl;
  let timerId = null;

  const startTimer = () => {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }

    timerId = setInterval(() => {
      timer -= 1;
    }, 60000);
  };

  const getTtlInMinutes = () => timer;

  const clearTimer = () => {
    timerId && clearInterval(timerId);
    timerId = null;
    timer = 0;
  };

  return {
    getTtlInMinutes,
    startTimer,
    clearTimer,
  };
};
